export const workingDaysList = [
    {
        text: 'calculator.Business-information.form.WFO.types.days-5',
        desc: 'calculator.Business-information.form.WFO.types.office',
        value: '5'
    },
    {
        text: 'calculator.Business-information.form.WFO.types.days-4',
        desc: 'calculator.Business-information.form.WFO.types.hybird',
        value: '4'
    },
    {
        text: 'calculator.Business-information.form.WFO.types.days-3',
        desc: 'calculator.Business-information.form.WFO.types.hybird',
        value: '3'
    },
    {
        text: 'calculator.Business-information.form.WFO.types.days-2',
        desc: 'calculator.Business-information.form.WFO.types.hybird',
        value: '2'
    },
    {
        text: 'calculator.Business-information.form.WFO.types.days-1',
        desc: 'calculator.Business-information.form.WFO.types.hybird',
        value: '1'
    },
    {
        text: 'calculator.Business-information.form.WFO.types.Remote',
        desc: 'calculator.Business-information.form.WFO.types.passes',
        value: '0'
    }
];
